import React, { useEffect, useState } from "react"
import '../styles.css'
import { useScroll, useTransform, motion } from 'framer-motion'
import ParallaxText from "../components/ParallaxText";
import ParallaxLine from "../components/ParallaxLine";
import axios from "axios";
import { VscGithub } from "react-icons/vsc";
import Navbar from "../components/Navbar";

const Projects = () => {
  
  const { scrollYProgress } = useScroll();
  const x = useTransform(scrollYProgress, [0, 0.1], [0, -500]);
  // const xText = useTransform(scrollY, [0, 1], [0, -600]);

  // framer animation
  const easing = [0.6, -0.5, 0.01, 0.99]

  const fadeInUp = {
    initial: {
      y: 60,
      opacity: 0
    },
    animate: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: easing
      }
    }
  }


  const [projects, setProjects] = useState([])
  useEffect(() => {
    axios.get('https://my-json-server.typicode.com/Achi00/projects-json/projects')
      .then(res => {
        setProjects(res.data)
      })
      .catch(err => {
        console.log(err)
      })
  }, [])

  return ( 
    <>

<div className="container" id="smooth-wrapper">
      <div id="smooth-content">
        <motion.h2
        initial={{ y: 1500 }}
        animate={{ y: 0}}
        transition={{
          type: "spring",
          stiffness: 2000,
          damping: 150,
          delay: 0.2
        }}
        variants={fadeInUp}
        >Front-End Developer / Student</motion.h2>
        <Navbar />
        <div className="content">
		      <motion.h1 initial={{ x: -1500 }}
        animate={{ x: 0}}
        transition={{
          type: "spring",
          stiffness: 2000,
          damping: 150,
          delay: 0.2
        }}
        variants={fadeInUp}
        >ACHI</motion.h1>
		      <motion.h1 initial={{ x: -1500 }}
        animate={{ x: 0}}
        transition={{
          type: "spring",
          stiffness: 2000,
          damping: 150,
          delay: 0.2
        }}
        variants={fadeInUp}
        >ACHI</motion.h1>
          <div className="headline">
            <motion.span initial={{ y: 1500 }}
        animate={{ y: 0}}
        transition={{
          type: "spring",
          stiffness: 2000,
          damping: 150,
          delay: 0.2
        }} className="head">P</motion.span>
            <motion.span initial={{ y: 1500 }}
        animate={{ y: 0}}
        transition={{
          type: "spring",
          stiffness: 2000,
          damping: 150,
          delay: 0.4
        }} className="head">R</motion.span>
            <motion.span initial={{ y: 1500 }}
        animate={{ y: 0}}
        transition={{
          type: "spring",
          stiffness: 2000,
          damping: 150,
          delay: 0.6
        }} className="head">O</motion.span>
            <motion.span initial={{ y: 1500 }}
        animate={{ y: 0}}
        transition={{
          type: "spring",
          stiffness: 2000,
          damping: 150,
          delay: 0.8
        }} className="head">J</motion.span>
            <motion.span initial={{ y: 1500 }}
        animate={{ y: 0}}
        transition={{
          type: "spring",
          stiffness: 2000,
          damping: 150,
          delay: 1
        }} className="head">E</motion.span>
            <motion.span initial={{ y: 1500 }}
        animate={{ y: 0}}
        transition={{
          type: "spring",
          stiffness: 2000,
          damping: 150,
          delay: 1.2
        }} className="head">C</motion.span>
            <motion.span initial={{ y: 1500 }}
        animate={{ y: 0}}
        transition={{
          type: "spring",
          stiffness: 2000,
          damping: 150,
          delay: 1.4
        }} className="head">T</motion.span>
            <motion.span initial={{ y: 1500 }}
        animate={{ y: 0}}
        transition={{
          type: "spring",
          stiffness: 2000,
          damping: 150,
          delay: 1.6
        }} className="head">S</motion.span>
          </div>
	      </div>
          <motion.h1
          initial={{ x: -1500 }}
          animate={{ x: 0}}
          transition={{
            type: "spring",
            stiffness: 1000,
            damping: 150,
            delay: 0
          }}
          variants={fadeInUp}>
            Projects are made with React, Next, R3F and Other.<br />
            I <span>always try my hardest to stand out from the crowd and spend a lot</span> of time coming up with<br />
            original and unique designs and solutions.
          </motion.h1>
          <div className="middle-line" />
          <ParallaxText />
          <div className="low-text">
            <h3>
            PORTFOLIO EXPLORATION
            </h3>
          </div>

            {
              projects.map(project => (
                <>
                <ParallaxLine />
                <motion.div
                key={project.id}
                  className='card'
                  >
                    <h1>{project.name}</h1>
                    <img
                    className='card-img'
                    src={project.image} alt="portfolio" />  
                    <div className="git">
                      <VscGithub className="git-icon" size="50px" />
                      <a className="link" href={project.github} target="_black">
                        Visit Github Page
                      </a>
                    </div>
                    <div className="link">
                      <a href={project.url} target="_black">Visit Website</a>
                    </div>
                  </motion.div>
                  </>
              ))
            }
            <h2>Achi Gorgadze</h2>
          <ParallaxLine />
      </div>
    </div>
    </>
  )
}

export default Projects